import React, { useMemo } from "react";
import { FormattedMessage } from "react-intl";
import type { IIntegrationFormImplProps } from "src/integrations/forms/IIntegrationFormImplProps";
import { ShopifyIsRestrictedInput } from "src/integrations/forms/shopify/inputs/ShopifyIsRestrictedInput";
import { INTEGRATION_SHOPIFY_META_OBJECT_TYPE } from "src/integrations/forms/shopify/IntegrationFormDataShopifyForm";
import { IntegrationFormShopify } from "src/integrations/forms/shopify/IntegrationFormShopify";
import { TextInput } from "src/shared/forms/inputs/TextInput";

export const IntegrationFormShopifyForm = (
  props: IIntegrationFormImplProps,
) => {
  const { isEdit } = props;
  const metaObjectTypeRegex = useMemo(() => new RegExp("^[a-zA-Z0-9_-]*$"), []);
  return (
    <IntegrationFormShopify {...props}>
      <TextInput
        inputID={INTEGRATION_SHOPIFY_META_OBJECT_TYPE}
        label={
          <FormattedMessage id="integrations.shopifyForms.metaobjectType" />
        }
        maxLength={128}
        regex={metaObjectTypeRegex}
        disabled={isEdit}
      />
      <ShopifyIsRestrictedInput {...props} />
    </IntegrationFormShopify>
  );
};
